import { Component, Input, OnInit } from '@angular/core';
import { InfobarBase } from '../../../../../components/common/infobar-base/infobar-base';
import { TabConfig } from '../../../../../components/common/pollux-tab-config/pollux-form-config';
import { ComparablesHostComponent } from '../../../comparables-host/comparables-host.component';
import { EventBusService } from '../../../../../services/event-bus.service';

/**
 * Infobar (sidebar)
 */
@Component({
  selector: 'comparables-infobar',
  templateUrl: './comparables-infobar.component.html'
})
export class ComparablesInfobarComponent extends InfobarBase implements OnInit {

  /**
  * Input main data.
  */
  @Input() main: ComparablesHostComponent;

  /**
  * Mode information
  */
  mode = 'property';

  /**
  * Infobar item
  */
  infobarItem = {};

  /**
  * Infobar type
  */
  infobarType = null;

  /**
  * Enable settings
  */
  enableSettings = null;

  /**
  * Constructor
  */
  constructor(private eventBus: EventBusService) {
    super();
  }

  /**
  * On init.
  */
  ngOnInit(): void {
    this.main.onInfobarCreated(this);
    //upon creation, infobar should be hidden (open on clicking an item)
    this.main.setInfoBarVisibility(false, true);
    this.subscribeToComparablesInfobarChange();
    this.subscribeToComparablesInfobarItemChanged();
    this.onEvents.push(this.eventBus.subscribeEvent('toolbarSetArea', (newArea, _options) => {
      this.setMode(newArea, null);
      this.main.setInfoBarVisibility(false, true);
    }));
  }

  /**
   * Subscribes to infobar change event
   * */
  subscribeToComparablesInfobarChange() {
    this.onEvents.push(this.eventBus.subscribeEvent('comparables-infobar-changed', (paramsObject, _options) => {
      if (paramsObject.areaChanged) {
        this.mode = 'none';
      }
      this.enableSettings = paramsObject.enableSettings;
      this.infobarType = paramsObject.params ? paramsObject.params.infobarType : this.infobarType;
    }));
  }

  /**
   * Subscribes to infobar item change event
   * */
  subscribeToComparablesInfobarItemChanged() {
    this.onEvents.push(this.eventBus.subscribeEvent('comparables-infobar-item-changed', (params, _options) => {
      const mode = params.mode;
      const item = params.item;
      const itemIdentityProperty = params.itemIdentityProperty;

      const changeItem = (mode === this.mode) // same infobar mode
        && (
          // item not set yet
          !this.infobarItem[mode]
          ||
          // had item and new is null
          (this.infobarItem[mode] && item === null)
          ||
          // item changed
          (this.infobarItem[mode][itemIdentityProperty] !== item[itemIdentityProperty])
        );

      if (changeItem) {
        this.setMode(mode, item);
      }
    }));
  }

  /**
   * On element selected action
   * @param tabItem Selected tab item
   * @param item Selected item
   */
  public onElementSelected(tabItem: TabConfig, item: any) {
    let mode = "none";
    if (tabItem.id === "tabProperty") {
      mode = "property";
      const infobarItemChanged = (item !== this.infobarItem[mode]);
      this.setMode(mode, infobarItemChanged ? item : null);
    } else {
      this.main.setInfoBarVisibility(false, true);
      this.setMode(mode, null);
    }
  }

  /**
   * Sets the infobar mode and item
   * @param mode Infobar mode
   * @param item Infobar item
   */
  setMode(mode, item) {
    this.infobarItem[mode] = item;
    this.mode = mode;
  }
}
